import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  //   mode: "history",
  mode: "hash",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: "/",
      redirect: {
        name: "login",
      },
    },
    {
      path: "/index",
      name: "index",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/index/index.vue"),
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/login.vue"),
    },
    {
      path: "/register",
      name: "register",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/register.vue"),
    },
    {
      path: "/forgetpwd",
      name: "forgetpwd",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/forgetpwd.vue"),
    },
    {
      path: "/setpwd",
      name: "setpwd",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/setpwd.vue"),
    },
    {
      path: "/setpaypwd",
      name: "setpaypwd",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/setpaypwd.vue"),
    },
    {
      path: "/about",
      name: "about",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/about.vue"),
    },
    {
      path: "/language",
      name: "language",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/language.vue"),
    },
    {
      path: "/member",
      name: "member",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/member.vue"),
    },
    {
      path: "/splashscreen",
      name: "splashScreen",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/splashScreen.vue"),
    },
    {
      path: "/moviedetail/:id",
      name: "movieDetail",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/movieDetail.vue"),
    },
    {
      path: "/events",
      name: "events",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/events.vue"),
    },
    {
      path: "/info/:id",
      name: "info",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/info.vue"),
    },
    {
      path: "/bonus",
      name: "bonus",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/bonus.vue"),
    },
    {
      path: "/bonusrules",
      name: "bonusrules",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/bonusrules.vue"),
    },
    {
      path: "/settings",
      name: "settings",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/settings.vue"),
    },
    {
      path: "/team",
      name: "team",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/team.vue"),
    },
    {
      path: "/teamdirectdownline",
      name: "teamdirectdownline",
      component: () =>
        import(
          /* webpackChunkName: "home" */ "./views/user/teamdirectdownline.vue"
        ),
    },
    {
      path: "/teamprofit",
      name: "teamprofit",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/teamprofit.vue"),
    },
    {
      path: "/setnickname",
      name: "setnickname",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/setnickname.vue"),
    },
    {
      path: "/setphone",
      name: "setphone",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/setphone.vue"),
    },
    {
      path: "/setemail",
      name: "setemail",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/setemail.vue"),
    },
    {
      path: "/movieinvest/:id",
      name: "movieinvest",
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/movieinvest.vue"),
    },
    {
      path: "/setwallet",
      name: "setwallet",
      props: true,
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/setwallet.vue"),
    },
    {
      path: "/setbankcard",
      name: "setbankcard",
      props: true,
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/setbankcard.vue"),
    },
    {
      path: "/fundingdetails",
      name: "fundingDetails",
      props: true,
      component: () =>
        import(/* webpackChunkName: "home" */ "./views/user/fundingDetails.vue"),
    },
  ],
});
